// extracted by mini-css-extract-plugin
export default {"Link":"LinkItem_Link__GFG0P"};